import useQueryParams from 'components/hooks/useQueryParams';
import { useMemo } from 'react';
import { TEAM_SPACE_TABS } from '../team-space.consts';
import { useLocation } from 'react-router';

const useDefaultTab = ({ activeIterations, pastIterations }) => {
  const location = useLocation();
  const { getQueryParam } = useQueryParams();
  const contextQs = getQueryParam('context');
  const iterationIdQs = getQueryParam('iteration_id');
  const locationDefaultTab = location?.state?.defaultTab;

  const defaultTab = useMemo(() => {
    if (locationDefaultTab) {
      return locationDefaultTab;
    }

    if (contextQs && iterationIdQs) {
      // link with team or team_iteration context
      const activeIteration = activeIterations.find(
        iteration => iteration?.id?.toString() === iterationIdQs
      );
      if (activeIteration) {
        return TEAM_SPACE_TABS.CURRENT;
      }
      const pastIteration = pastIterations.find(
        iteration => iteration => iteration?.id?.toString() === iterationIdQs
      );
      if (pastIteration) return TEAM_SPACE_TABS.COMPLETED;
    }

    return TEAM_SPACE_TABS.COMPLETED;
  }, [
    activeIterations,
    pastIterations,
    contextQs,
    iterationIdQs,
    locationDefaultTab
  ]);

  return defaultTab;
};

export default useDefaultTab;
